import { api } from './auth';

const insuranceAPI = api.injectEndpoints({
    endpoints: (builder) => ({
        createConsent: builder.mutation({
            query: (consentData) => ({
                url: `/consents`,
                method: 'POST',
                body: { documents: consentData },
            }),
        }),
        checkEligibility: builder.mutation({
            query: (userId) => ({
                url: `/users/${userId}/insurance/check-eligibility`,
                method: 'POST',
            }),
        }),
        createPatientInsurance: builder.mutation({
            query: ({ userId, data }) => ({
                url: `/users/${userId}/insurance`,
                method: 'POST',
                body: data,
            }),
            invalidatesTags: ['Insurance'],
        }),
        getMyInsurance: builder.query({
            query: (userId) => ({
                url: `/users/${userId}/insurance?inactive=true`,
                method: 'GET',
            }),
            transformResponse: (response, meta, arg) => {
                const activeInsurance = response.find((insurance) =>
                    ['Active', 'Review', 'Failed'].includes(insurance.insuranceStatus),
                );
                return activeInsurance;
            },
            providesTags: (result, error, arg) =>
                result ? [{ type: 'Insurance', id: arg?.userId }] : [],
        }),
        getOrganization: builder.query({
            query: (id) => `/organization/${id}`,
            providesTags: (result) => [{ type: 'Organization', id: result?.id }],
        }),
        getPatientConsents: builder.query({
            query: () => ({
                url: `/consents`,
            }),
        }),
        getPayers: builder.query({
            query: () => ({
                url: `/payers`,
                method: 'GET',
            }),
            providesTags: ['Payers'],
        }),
        getStateServices: builder.query({
            query: (state) => ({
                url: `/service/${state}`,
                method: 'GET',
            }),
        }),
        updatePatientInsurance: builder.mutation({
            query: ({ userId, insuranceId, data }) => ({
                url: `/users/${userId}/insurance/${insuranceId}`,
                method: 'PUT',
                body: data,
            }),
            invalidatesTags: ['Insurance', 'OrderInfo', 'OrderHistory', 'PatientOrderHistory'],
        }),
    }),
    overrideExisting: false,
});

export const {
    useCreateConsentMutation,
    useCheckEligibilityMutation,
    useCreatePatientInsuranceMutation,
    useGetMyInsuranceQuery,
    useGetOrganizationQuery,
    useGetPartnerOrganizationsQuery,
    useGetPatientConsentsQuery,
    useGetPayersQuery,
    useGetStateServicesQuery,
    useLazyGetMyInsuranceQuery,
    useUpdatePatientInsuranceMutation,
} = insuranceAPI;
